// Objetivo: Funções utilitárias que podem ser utilizadas em qualquer lugar do projeto
import { useAuthStore } from "@/stores/auth";
import { useRuntimeConfig } from "@/composables/useRuntimeConfig";

const { isDebugEnabled, getConfig } = useRuntimeConfig();

export function getUfs() {
    return [
        { sigla: 'AC', nome: 'Acre' },
        { sigla: 'AL', nome: 'Alagoas' },
        { sigla: 'AP', nome: 'Amapá' },
        { sigla: 'AM', nome: 'Amazonas' },
        { sigla: 'BA', nome: 'Bahia' },
        { sigla: 'CE', nome: 'Ceará' },
        { sigla: 'DF', nome: 'Distrito Federal' },
        { sigla: 'ES', nome: 'Espírito Santo' },
        { sigla: 'GO', nome: 'Goiás' },
        { sigla: 'MA', nome: 'Maranhão' },
        { sigla: 'MT', nome: 'Mato Grosso' },
        { sigla: 'MS', nome: 'Mato Grosso do Sul' },
        { sigla: 'MG', nome: 'Minas Gerais' },
        { sigla: 'PA', nome: 'Pará' },
        { sigla: 'PB', nome: 'Paraiba' },
        { sigla: 'PR', nome: 'Paraná' },
        { sigla: 'PE', nome: 'Pernambuco' },
        { sigla: 'PI', nome: 'Piauí' },
        { sigla: 'RJ', nome: 'Rio de Janeiro' },
        { sigla: 'RN', nome: 'Rio Grande do Norte' },
        { sigla: 'RS', nome: 'Rio Grande do Sul' },
        { sigla: 'RO', nome: 'Rondônia' },
        { sigla: 'RR', nome: 'Roraima' },
        { sigla: 'SC', nome: 'Santa Catarina' },
        { sigla: 'SP', nome: 'São Paulo' },
        { sigla: 'SE', nome: 'Sergipe' },
        { sigla: 'TO', nome: 'Tocantins' },
    ]
}

export function showLogConsole(dado, params) {
    if (isDebugEnabled.value) {
        console.log(dado, params);
    }
}

export function permutaSolicitacaoContratacao(nome) {
    if (nome) {
        return nome.replace("Solicitação", "Contratação");
    }
    return nome
}

export function permutaSolicitacaoPagamento(nome) {
    if (!nome) return "Solicitação";
    if (nome) {
        if (nome === "Solicitação de Empréstimo") {
            return nome.replace("Solicitação de ", "Concessão de ");
        }
        return nome.includes("Solicitação de Pagamento")
            ? nome.replace("Solicitação de ", "")
            : nome.replace("Solicitação", "Pagamento");
    }
    return nome;
}

export function generatePassword() {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const passwordLength = 8;
    var password = "";
    for (var i = 0; i <= passwordLength; i++) {
        const randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber + 1);
    }
    return password
}

export function buscarItemPorId(lista, id) {
    var index = -1;
    for (var i = 0; i < lista.length; i++) {
        if (lista[i].id === id) {
            index = i;
            break;
        }
    }
    return index;
}

export function buscarItemPorNome(lista, nome) {
    var index = -1
    for (var i = 0; i < lista.length; i++) {
        if (lista[i].nome === nome) {
            index = i;
            return i;
        }
    }
    return index;
};

export function ehVazio(valor) {
    return valor === null || valor === undefined || valor === '';
};

export function validarPermissao(permissao) {
    const authStore = useAuthStore();

    const usuarioPermissoes = authStore.getUsuarioPermissoes();

    if (usuarioPermissoes.includes(permissao) || usuarioPermissoes.includes('all:all')) {
        return true;
    } else {
        return false;
    }
}

export function formataDataChefiaSetor(datainicio, datafim) {
    if (datainicio && datafim) {
        const dataInicio = new Date(datainicio + 'T00:00:00')
        const dataFim = new Date(datafim + 'T00:00:00')
        if (dataFim < dataInicio) {
            return dataInicio.toLocaleDateString('pt-BR');
        }
        if (dataFim.getTime() === dataInicio.getTime()) {
            return dataInicio.toLocaleDateString('pt-BR');
        }
        return `${dataInicio.toLocaleDateString('pt-BR')} até ${dataFim.toLocaleDateString('pt-BR')}`;
    } else if (datainicio && !datafim) {
        const dataInicio = new Date(datainicio + 'T00:00:00')
        return dataInicio.toLocaleDateString('pt-BR');
    }
}

export function formataDataRetirandoHora(datastr) {
    // A data de entrada será uma string no formato: "2025-05-21T17:57:10.058390" ou "2025-05-21"
    // A data de saída será uma string no formato: "21/05/2025"
    if (datastr) {
        const data = new Date(datastr);
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
        const ano = data.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }
}

export function formataDataSemFuso(datastr) {
    // Formata uma data ignorando o fuso horário, para evitar que datas no formato
    // "2025-05-18" sejam convertidas para o dia anterior por causa do UTC.
    // A data de entrada pode ser "2025-05-18" ou "2025-05-18T17:57:10.058390".
    // A data de saída será uma string no formato: "18/05/2025"
    if (datastr) {
        const [ano, mes, dia] = datastr.split('T')[0].split('-');
        return `${dia}/${mes}/${ano}`;
    }
}

export function formataDataFromDb(datastr) {
    const data = new Date(datastr + 'T00:00:00')
    return data.toLocaleDateString('pt-BR')
}

export function formataDataHoraFromDb(datastr) {
    const data = new Date(datastr + 'Z')   // datastr +'Z'
    return data.toLocaleString('pt-BR')
}

export function formataDataSemHoraFromDb(datastr) {
    const data = new Date(datastr + 'Z')
    return data.toLocaleDateString('pt-BR')
}

export function isForaDeVigencia(vigenciaFim) {
    if (!vigenciaFim) return false;
    const [year, month, day] = vigenciaFim.split('-').map(Number);
    const fim = new Date(year, month - 1, day);
    const hoje = new Date();
    const hojeLocal = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
    return hojeLocal > fim;
}

export function formataDiaMesFromDb(datastr) {
    const data = new Date(datastr + 'Z')
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    return `${dia}/${mes}`;
}

export function formataDataInt(datastr) {
    // A data de entrada será um int do tipo: 7022025 ou 10032025
    // A data de saída será uma string no formato: 07/02/2025 ou 10/03/2025
    if (datastr) {
        let data = datastr.toString();
        let dia = data.length === 7 ? '0' + data.substring(0, 1) : data.substring(0, 2);
        let mes = data.length === 7 ? data.substring(1, 3) : data.substring(2, 4);
        let ano = data.substring(data.length - 4);
        return `${dia}/${mes}/${ano}`;
    }
}

export function formataMesAno(datastr) {
    // A data de saída será uma string no formato: "05/2025"
    if (datastr) {
        const [ano, mes] = datastr.split('-');
        return `${mes}/${ano}`;
    }
}

export function mudaFormatoDataSep(datastr) {
    if (datastr) {
        if (datastr.search('/') >= 0) {
            let novaData = datastr.split('/')
            novaData = novaData[2] + '-' + novaData[1] + '-' + novaData[0] // Formatar data para YYYY-MM-DD
            return novaData
        } else if (datastr.search('-') >= 0) {
            let novaData = datastr.split('-')
            novaData = novaData[2] + '/' + novaData[1] + '/' + novaData[0] // Formatar data para DD/MM/YYYY
            return novaData
        }
    }
}

export function converterParaDataIso(dataString) {
    const [dia, mes, ano] = dataString.split('/');
    return `${ano}/${mes}/${dia}`;
};

export function mudaFormatoMesAno(datastr) {
    if (datastr) {
        if (datastr.search('/') >= 0) {
            let novaData = datastr.split('/')
            novaData = novaData[1] + '-' + novaData[0] // Formatar data para MM/YYYY
            return novaData
        } else if (datastr.search('-') >= 0) {
            let novaData = datastr.split('-')
            novaData = novaData[1] + '/' + novaData[0] // Formatar data para MM/YYYY
            return novaData
        }
    }
}
export function formataMoedaReais(valor) {
    const reais = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
    return reais.format(valor)
}

export function formataCpf(cpf, mascarar = true) {
    if (cpf) {
        if (mascarar) {
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "***.$2.$3-**")
        } else {
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
        }
    }
}

export function formataCnpj(cnpj, mascarar = false) {
    if (cnpj) {
        if (mascarar) {
            return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "**.$2.$3/$4-**")
        } else {
            return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
        }
    }
}

export function validarCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, ''); // Remove pontos e traços

    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    // Valida primeiro dígito
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    // Valida segundo dígito
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
}

export function validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

    const calcularDigito = (base, pesos) => {
        let soma = 0;
        for (let i = 0; i < pesos.length; i++) {
            soma += parseInt(base[i]) * pesos[i];
        }
        let resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const base = cnpj.slice(0, 12);
    const digito1 = calcularDigito(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    const digito2 = calcularDigito(base + digito1, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

    return cnpj === base + digito1 + '' + digito2;
}

export function formataNis(nis) {
    if (nis) {
        return nis.replace(/(\d{3})(\d{5})(\d{2})(\d{1})/, "$1.$2.$3-$4")
    }
}

export function formataCep(cep) {
    if (cep) {
        return cep.replace(/(\d{5})(\d{3})/, "$1-$2")
    }
}

// Recebe uma data no formato "yyyy-mm-dd" e retorna o mês de referência no formato "mm/yyyy"
export function formataDataMesReferencia(data) {
    if (data) {
        const partes = data.split('-');
        if (partes.length === 3) {
            const ano = partes[0];
            const mes = partes[1];
            return `${mes}/${ano}`;
        } else if (partes.length === 2) {
            const mes = partes[0];
            const ano = partes[1];
            return `${mes}/${ano}`;
        }
    }
    return "";
}

// Formata o nome para exibir no sistema o primeiro e o último nome
// Exemplo: ALEX FABIANO DE ARAÚJO FURTUNATO -> Alex Furtunato
export function formataNome(nome) {
    if (!nome) return "";
    const partes = nome.trim().split(" ");
    const formatarParte = (parte) => parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase();

    if (partes.length >= 2) {
        return `${formatarParte(partes[0])} ${formatarParte(partes[partes.length - 1])}`;
    }

    return formatarParte(partes[0]);
}

export function removerPontuacao(valor) {
    if (!valor) return valor;

    // Remove espaços extras para análise
    const valorSemEspacos = valor.trim();

    // Conta quantos caracteres são dígitos
    const digitos = (valorSemEspacos.match(/\d/g) || []).length;
    // Conta quantos caracteres são letras
    const letras = (valorSemEspacos.match(/[a-zA-ZÀ-ÿ]/g) || []).length;

    // Se tem mais dígitos que letras, é provavelmente um documento (CPF/CNPJ)
    // então remove a pontuação e espaços
    if (digitos > letras) {
        return valor.replace(/\s+/g, '').replace(/[.\-/]/g, '');
    }

    // Se tem mais letras, é provavelmente um nome, mantém como está
    return valor;
};

export function formataLogradouroChefiaSetor(logradouro, numero, bairro) {
    let endereco = logradouro;
    if (numero) {
        endereco += `, ${numero}`;
    }
    if (bairro) {
        endereco += ` - ${bairro}`;
    }
    return endereco;
}

export function formataCidadeEstadoChefiaSetor(cidade, estado) {
    let cidadeEstado = cidade;
    if (estado) {
        cidadeEstado += ` - ${estado}`;
    }
    return cidadeEstado;
}

export function truncarNumero(valor) {
    if (valor === null || valor === undefined || valor === '') return valor;

    const numero = typeof valor === 'string' ? Number(valor) : valor;
    if (Number.isNaN(numero)) return valor;

    return Math.trunc(numero);
}

export function formatarDataExtrato(data) {
    // Espera receber um inteiro como 7022025 e retorna "07/02/2025"
    if (!data) return "";
    let str = data.toString();
    let dia = str.length === 7 ? '0' + str[0] : str.substring(0, 2);
    let mes = str.length === 7 ? str.substring(1, 3) : str.substring(2, 4);
    let ano = str.slice(-4);
    return `${dia}/${mes}/${ano}`;
}

// Formata o nome para exibir no sistema, retirando preposições e mantendo a string completa
// Exemplo: ALEX FABIANO DE ARAÚJO FURTUNATO -> Alex Fabiano de Araújo Furtunato
export function formataNomePessoal(nome) {
    let preposicoes = ["da", "de", "do", "das", "dos", "e"];
    let partes = nome.split(" ");
    let nomeFormatado = "";
    for (let i = 0; i < partes.length; i++) {
        if (preposicoes.includes(partes[i].toLowerCase())) {
            nomeFormatado += partes[i].toLowerCase() + " ";
        } else {
            nomeFormatado += partes[i].charAt(0).toUpperCase() + partes[i].slice(1).toLowerCase() + " ";
        }
    }
    return nomeFormatado.trim();
}

export function formataTelefone(telefone) {
    if (telefone) {
        if (telefone.length == 10) {
            return telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3")
        }
        else if (telefone.length == 11) {
            return telefone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
        }

    }
}

export function removeMascaraTelefoneCpfCnpj(valor) {
    if (valor) {
        return valor.replace(/[^0-9]/g, '')
    }
}

export function isValidDate(dateString) {
    const [dia, mes, ano] = dateString.split('/').map(Number);
    const data = new Date(ano, mes - 1, dia);

    // Verificamos se os valores fornecidos correspondem aos valores da data criada
    return (
        data.getFullYear() === ano &&
        data.getMonth() + 1 === mes && // Somamos 1 porque getMonth() retorna o mês começando em 0
        data.getDate() === dia
    );
}

export function isValidDateMesAno(dateString) {
    const [mes, ano] = dateString.split('/').map(Number);

    const data = new Date(ano, mes - 1, 1);
    if (isNaN(data.getTime())) return false;

    return data.getMonth() + 1 === mes && data.getFullYear() === ano;
}

export function tagStatusHistoricoChefia(ativa, datainicio, datafim) {
    const dataHoje = new Date().toISOString().slice(0, 10);
    if (ativa === true) {
        return {
            label: 'Ativa',
            classe: 'border-round-md text-cyan-700 font-medium bg-cyan-100'
        };
    } else if (ativa === false && datainicio > dataHoje) {
        return {
            label: 'Programada',
            classe: 'border-round-md text-purple-700 font-medium bg-purple-100'
        };
    } else if (ativa === false && datafim < dataHoje) {
        return {
            label: 'Concluída',
            classe: 'border-round-md text-green-700 font-medium bg-green-100'
        };
    }
    return {
        label: '-',
        classe: 'border-round-md text-green-700 font-medium bg-green-100'
    };
}

export function tagStatusProcesso(processo) {
    // Fonte unica: o proprio nome do status (vindo do .env) define rotulo e cor da tag.
    const coresStatusProcesso = {
        [tipo_status_processo_registrado]: 'azul',
        [tipo_status_processo_em_tramite]: 'azul',
        [tipo_status_processo_encaminhado]: 'roxo',
        [tipo_status_processo_em_analise]: 'amarelo',
        [tipo_status_processo_aguardando_documentos_solicitante]: 'laranja',
        [tipo_status_processo_aguardando_assinatura]: 'amarelo',
        [tipo_status_processo_concluido]: 'verde',
        [tipo_status_processo_resolvido]: 'verde',
        [tipo_status_processo_cancelado]: 'vermelho',
        [tipo_status_processo_deferido]: 'verde',
        [tipo_status_processo_indeferido]: 'vermelho',
    };

    const label = processo?.status_atual?.nome || '-';
    return { label, cor: coresStatusProcesso[label] ?? 'cinza' };
}

// Status possiveis de uma autorizacao de processo, na ordem em que a API os define.
export const opcoesStatusAutorizacao = [
    { label: 'Pendente', value: 'pendente' },
    { label: 'Autorizado', value: 'autorizado' },
    { label: 'Recusado', value: 'recusado' },
    { label: 'Cancelado', value: 'cancelado' },
];

export function tagStatusAutorizacao(status) {
    const coresStatusAutorizacao = {
        pendente: 'amarelo',
        autorizado: 'verde',
        recusado: 'vermelho',
        cancelado: 'cinza',
    };

    const opcao = opcoesStatusAutorizacao.find((o) => o.value === status);
    return { label: opcao?.label ?? (status || '-'), cor: coresStatusAutorizacao[status] ?? 'cinza' };
}

export function tagHistoricoProcesso(referenciaTipo) {
    switch (referenciaTipo) {
        case 'criacao':
            return {
                icon: 'person',
                classe: 'bg-yellow-50 text-yellow-600 border-yellow-400 border-1',
            };
        case 'alteracao_status':
            return {
                icon: 'sync',
                classe: 'bg-green-50 text-green-600 border-green-400 border-1',
            };
        case 'alteracao_responsavel':
            return {
                icon: 'people',
                classe: 'bg-blue-50 text-blue-600 border-blue-400 border-1',
            };
        case 'alteracao_prioridade':
            return {
                icon: 'flag',
                classe: 'bg-orange-50 text-orange-600 border-orange-400 border-1',
            };
        case 'alteracao_prazo':
            return {
                icon: 'schedule',
                classe: 'bg-purple-50 text-purple-600 border-purple-400 border-1',
            };
        case 'tramitacao':
            return {
                icon: 'box',
                classe: 'bg-cyan-50 text-cyan-600 border-cyan-400 border-1',
            };
        case 'anexo':
            return {
                icon: 'attach_file',
                classe: 'bg-teal-50 text-teal-600 border-teal-400 border-1',
            };
        case 'comentario':
            return {
                icon: 'comment',
                classe: 'bg-blue-50 text-blue-600 border-blue-400 border-1',
            };
        case 'despacho':
            return {
                icon: 'gavel',
                classe: 'bg-red-50 text-red-600 border-red-400 border-1',
            };
        case 'autorizacao':
            return {
                icon: 'approval',
                classe: 'bg-indigo-50 text-indigo-600 border-indigo-400 border-1',
            };
        case 'observador':
            return {
                icon: 'visibility',
                classe: 'bg-red-50 text-red-600 border-red-400 border-1',
            };
        case 'arquivamento':
            return {
                icon: 'archive',
                classe: 'bg-gray-50 text-gray-600 border-gray-400 border-1',
            };
        case 'conclusao':
            return {
                icon: 'check_circle',
                classe: 'bg-green-50 text-green-600 border-green-400 border-1',
            };
        default:
            return {
                icon: 'info',
                classe: 'bg-gray-50 text-gray-600 border-gray-400 border-1',
            };
    }
}

// Status de documento administrativo, como vem do back -> rotulo legivel + cor da tag
const STATUS_DOCUMENTO_ADMINISTRATIVO = {
    'RASCUNHO': { label: 'Rascunho', cor: 'cinza' },
    'AGUARDANDO_ASSINATURAS': { label: 'Aguardando Assinaturas', cor: 'amarelo' },
    'ASSINADO': { label: 'Assinado', cor: 'verde' },
    'PROCESSO_ABERTO': { label: 'Processo Aberto', cor: 'cyan' },
    'CANCELADO': { label: 'Cancelado', cor: 'vermelho' },
};

// Ação do histórico de documento administrativo -> ícone e cor do marcador na linha do tempo
const ACOES_HISTORICO_DOCUMENTO_ADMINISTRATIVO = {
    'CRIADO': { icon: 'note_add', classe: 'bg-yellow-50 text-yellow-600 border-yellow-400 border-1' },
    'ASSINATURA_SOLICITADA': { icon: 'send', classe: 'bg-blue-50 text-blue-600 border-blue-400 border-1' },
    'SIGNATARIOS_ADICIONADOS': { icon: 'person_add', classe: 'bg-blue-50 text-blue-600 border-blue-400 border-1' },
    'SIGNATARIOS_REMOVIDOS': { icon: 'person_remove', classe: 'bg-orange-50 text-orange-600 border-orange-400 border-1' },
    'ASSINADO': { icon: 'draw', classe: 'bg-green-50 text-green-600 border-green-400 border-1' },
    'ASSINATURA_NEGADA': { icon: 'block', classe: 'bg-red-50 text-red-600 border-red-400 border-1' },
    'SOLICITACAO_CANCELADA': { icon: 'cancel', classe: 'bg-red-50 text-red-600 border-red-400 border-1' },
    'ASSINATURAS_CONCLUIDAS': { icon: 'task_alt', classe: 'bg-green-50 text-green-600 border-green-400 border-1' },
    'UPLOAD_ASSINADO': { icon: 'upload_file', classe: 'bg-teal-50 text-teal-600 border-teal-400 border-1' },
    'SOLICITACAO_REABERTA': { icon: 'restart_alt', classe: 'bg-purple-50 text-purple-600 border-purple-400 border-1' },
    'PROCESSO_ABERTO': { icon: 'folder_open', classe: 'bg-cyan-50 text-cyan-600 border-cyan-400 border-1' },
};

export function tagHistoricoDocumentoAdministrativo(acao) {
    return ACOES_HISTORICO_DOCUMENTO_ADMINISTRATIVO[acao] ?? { icon: 'info', classe: 'bg-gray-50 text-gray-600 border-gray-400 border-1' };
}

export function tagStatusDocumentoAdministrativo(status) {
    const chave = removeAssentos(String(status ?? '')).trim().toUpperCase().replace(/\s+/g, '_');
    if (!chave) return;
    return STATUS_DOCUMENTO_ADMINISTRATIVO[chave] ?? { label: status, cor: 'cinza' };
}

export function formataDataExtenso(datastr) {
    if (datastr) {
        const data = datastr.includes('T') ? new Date(datastr) : new Date(datastr + 'T00:00:00');
        if (isNaN(data.getTime())) return '-';
        const dia = data.getDate();
        const mes = data.toLocaleString('pt-BR', { month: 'long' });
        const ano = data.getFullYear();
		return `${dia} de ${mes}, ${ano}`;
    }
    return '-';
}

// Formata a data por extenso com dia da semana, capitalizando o dia e o mês
// Exemplo: Terça-feira, 15 de Setembro de 2026
export function formataDataCompletaExtenso(data = new Date()) {
    return data
        .toLocaleDateString('pt-BR', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        })
        .replace(/^(\w)/, (c) => c.toUpperCase())
        .replace(/de (\w)/, (_, c) => `de ${c.toUpperCase()}`);
}

export function locale_pt_br() {
    return {
        "startsWith": "Começa com",
        "contains": "Contém",
        "notContains": "Não contém",
        "endsWith": "Termina com",
        "equals": "Igual",
        "notEquals": "Diferente",
        "noFilter": "Sem Filtro",
        "filter": "Filtro",
        "lt": "Menor que",
        "lte": "Menor ou igual a",
        "gt": "Maior que",
        "gte": "Maior ou igual a",
        "dateIs": "Data é",
        "dateIsNot": "Data não é",
        "dateBefore": "Data antes de",
        "dateAfter": "Data depois de",
        "custom": "Personalizado",
        "clear": "Limpar",
        "apply": "Aplicar",
        "matchAll": "Corresponder Todos",
        "matchAny": "Corresponder Qualquer",
        "addRule": "Adicionar Regra",
        "removeRule": "Remover Regra",
        "accept": "Sim",
        "reject": "Não",
        "choose": "Escolher",
        "upload": "Enviar",
        "cancel": "Cancelar",
        "completed": "Concluído",
        "pending": "Pendente",
        "fileSizeTypes": ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        "dayNames": ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
        "dayNamesShort": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        "dayNamesMin": ["D", "S", "T", "Q", "Q", "S", "S"],
        "monthNames": ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        "monthNamesShort": ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        "chooseYear": "Escolher Ano",
        "chooseMonth": "Escolher Mês",
        "chooseDate": "Escolher Data",
        "prevDecade": "Década Anterior",
        "nextDecade": "Próxima Década",
        "prevYear": "Ano Anterior",
        "nextYear": "Próximo Ano",
        "prevMonth": "Mês Anterior",
        "nextMonth": "Próximo Mês",
        "prevHour": "Hora Anterior",
        "nextHour": "Próxima Hora",
        "prevMinute": "Minuto Anterior",
        "nextMinute": "Próximo Minuto",
        "prevSecond": "Segundo Anterior",
        "nextSecond": "Próximo Segundo",
        "am": "AM",
        "pm": "PM",
        "today": "Hoje",
        "now": "Agora",
        "weekHeader": "Sem",
        "firstDayOfWeek": 0,
        "showMonthAfterYear": false,
        "dateFormat": "dd/MM/yy",
        "weak": "Fraco",
        "medium": "Médio",
        "strong": "Forte",
        "passwordPrompt": "Digite uma senha",
        "emptyFilterMessage": "Nenhum resultado encontrado",
        "searchMessage": "Existem {0} resultados disponíveis",
        "selectionMessage": "{0} itens selecionados",
        "emptySelectionMessage": "Nenhum item selecionado",
        "emptySearchMessage": "Nenhum resultado encontrado",
        "emptyMessage": "Nenhuma opção disponível",
        "aria": {
            "trueLabel": "Verdadeiro",
            "falseLabel": "Falso",
            "nullLabel": "Não Selecionado",
            "star": "1 estrela",
            "stars": "{star} estrelas",
            "selectAll": "Todos os itens selecionados",
            "unselectAll": "Todos os itens desmarcados",
            "close": "Fechar",
            "previous": "Anterior",
            "next": "Próximo",
            "navigation": "Navegação",
            "scrollTop": "Rolar para o Topo",
            "moveTop": "Mover para o Topo",
            "moveUp": "Mover para Cima",
            "moveDown": "Mover para Baixo",
            "moveBottom": "Mover para o Final",
            "moveToTarget": "Mover para o Destino",
            "moveToSource": "Mover para a Origem",
            "moveAllToTarget": "Mover Todos para o Destino",
            "moveAllToSource": "Mover Todos para a Origem",
            "pageLabel": "Página {page}",
            "firstPageLabel": "Primeira Página",
            "lastPageLabel": "Última Página",
            "nextPageLabel": "Próxima Página",
            "previousPageLabel": "Página Anterior",
            "rowsPerPageLabel": "Linhas por página",
            "jumpToPageDropdownLabel": "Ir para a Página",
            "jumpToPageInputLabel": "Ir para a Página",
            "selectRow": "Linha Selecionada",
            "unselectRow": "Linha Desmarcada",
            "expandRow": "Expandir Linha",
            "collapseRow": "Recolher Linha",
            "showFilterMenu": "Mostrar Menu de Filtro",
            "hideFilterMenu": "Esconder Menu de Filtro",
            "filterOperator": "Operador de Filtro",
            "filterConstraint": "Restrição de Filtro",
            "editRow": "Editar Linha",
            "saveEdit": "Salvar Edição",
            "cancelEdit": "Cancelar Edição",
            "listView": "Visualização de Lista",
            "gridView": "Visualização de Grade",
            "slide": "Deslizar",
            "slideNumber": "Slide {slideNumber}",
            "zoomImage": "Ampliar Imagem",
            "zoomIn": "Ampliar",
            "zoomOut": "Reduzir",
            "rotateRight": "Rotacionar para a Direita",
            "rotateLeft": "Rotacionar para a Esquerda"
        }
    }
}

export function formataTamanhoArquivo(bytes) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

export function openPDF(file) {
    if (!(file instanceof Blob)) {
        showLogConsole('O objeto passado não é um Blob:', file);
        return;
    }

    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
    URL.revokeObjectURL(fileURL);
};

export function removeAssentos(texto) {
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ç/g, "c");
}

// Textos vindos da API chegam em caixa variável (ex.: "PENDENTE"): normaliza para
// "Pendente". Diferente da classe CSS `capitalize`, que não rebaixa o resto do texto.
export function capitalizaPrimeiraLetra(texto) {
    const valor = String(texto ?? '');
    return valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
}

// Impede que o usuário comece a digitar por espaço, sem atrapalhar os espaços
// entre palavras. Usado no @input/@update:model-value dos campos de texto.
export function removeEspacoInicial(valor) {
    if (valor) {
        return valor.trimStart();
    }
    return valor;
}

// Extrai o texto puro de um HTML vindo de editor rich text, para validar conteúdo
// real: um editor vazio ainda devolve marcação (ex.: "<p></p>").
export function extrairTextoHtml(html) {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}

export const grupoUsuario_analistaprojeto = import.meta.env.VITE_GRUPO_USUARIO_ANALISTAPROJETO;
export const grupoUsuario_admins = import.meta.env.VITE_GRUPO_USUARIO_ADMINS;
export const grupoUsuario_administrador = import.meta.env.VITE_GRUPO_USUARIO_ADMINISTRADOR;
export const grupoUsuario_analistacrci = import.meta.env.VITE_GRUPO_USUARIO_ANALISTACRCI;
export const grupoUsuario_analistafinanceiro = import.meta.env.VITE_GRUPO_USUARIO_ANALISTAFINANCEIRO;
export const grupoUsuario_analistacompra = import.meta.env.VITE_GRUPO_USUARIO_ANALISTACOMPRAS;
export const grupoUsuario_bolsistasprojetos = import.meta.env.VITE_GRUPO_USUARIO_BOLSISTASPROJETOS;
export const grupoUsuario_gestores = import.meta.env.VITE_GRUPO_USUARIO_GESTORES;
export const grupoUsuario_ordenadordespesa = import.meta.env.VITE_GRUPO_USUARIO_ORDENADORDESPESA;
export const grupoUsuario_pessoal = import.meta.env.VITE_GRUPO_USUARIO_PESSOAL;
export const grupoUsuario_coordenador = import.meta.env.VITE_GRUPO_USUARIO_COORDENADOR;
export const grupoUsuario_subcoordenador = import.meta.env.VITE_GRUPO_USUARIO_SUBCOORDENADOR;
export const grupoUsuario_contabilidade = import.meta.env.VITE_GRUPO_USUARIO_CONTABILIDADE;
export const grupoUsuario_recursoshumanos = import.meta.env.VITE_GRUPO_USUARIO_RECURSOS_HUMANOS;
export const grupoUsuario_visualizadorcompras = import.meta.env.VITE_GRUPO_USUARIO_VISUALIZADORCOMPRAS;
export const grupoUsuario_funcionario = import.meta.env.VITE_GRUPO_USUARIO_FUNCIONARIO;
export const grupoUsuario_prestacaodecontas = import.meta.env.VITE_GRUPO_USUARIO_PRESTACAODECONTAS;

// Perfil de quem não pertence a nenhum grupo. É um sentinela interno do frontend,
// não um grupo do backend: serve apenas para escolher o painel inicial e o rótulo
// da topbar. O backend não conhece este valor.
export const PERFIL_PADRAO = '__padrao__';

export const tem_termo_autorizacao = getConfig('TEM_TERMO_AUTORIZACAO', false);
export const matricula_aluno_obrigatoria = getConfig('MATRICULA_ALUNO_OBRIGATORIA', false);

export const tipo_pagamento_boleto = import.meta.env.VITE_TIPO_PAGAMENTO_BOLETO;
export const tipo_pagamento_transferencia = import.meta.env.VITE_TIPO_PAGAMENTO_TRANSFERENCIA;
export const tipo_pagamento_pix = import.meta.env.VITE_TIPO_PAGAMENTO_PIX;
export const tipo_pagamento_swf = import.meta.env.VITE_TIPO_PAGAMENTO_SWF;
export const tipo_pagamento_gru = import.meta.env.VITE_TIPO_PAGAMENTO_GRU;
export const tipo_pagamento_ted = import.meta.env.VITE_TIPO_PAGAMENTO_TED;
export const tipo_pagamento_poupanca = import.meta.env.VITE_TIPO_PAGAMENTO_POUPANCA;
export const tipo_pagamento_pixqrcode = import.meta.env.VITE_TIPO_PAGAMENTO_PIXQRCODE;

/**
 * Fonte unica da apresentacao da forma de pagamento, nos dois contextos em que
 * ela aparece: a tag do detalhe (sigla + cor semantica da tag) e o texto das
 * listagens (descricao + classe de cor). Manter os dois no mesmo mapa evita que
 * um tipo novo entre em um lugar e falte no outro.
 *
 * @param {string} tipo_pagamento - sigla vinda da API (BOL, TRF, PIX...).
 * @returns {{ sigla: string, descricao: string, cor: string, classeTexto: string }}
 */
export function formaPagamento(tipo_pagamento) {
    const formas = {
        [tipo_pagamento_boleto]: { sigla: 'BOLETO', descricao: 'Via Boleto', cor: 'azul', classeTexto: 'text-blue-500' },
        [tipo_pagamento_pix]: { sigla: 'PIX', descricao: 'Via PIX', cor: 'verde', classeTexto: 'text-green-500' },
        [tipo_pagamento_swf]: { sigla: 'SWF', descricao: 'Via SWF', cor: 'indigo', classeTexto: 'text-indigo-400' },
        [tipo_pagamento_transferencia]: { sigla: 'TRF', descricao: 'Via Transf. Bancária', cor: 'roxo', classeTexto: 'text-purple-600' },
        [tipo_pagamento_gru]: { sigla: 'GRU', descricao: 'Via GRU', cor: 'rosa', classeTexto: 'text-pink-500' },
        [tipo_pagamento_ted]: { sigla: 'TED', descricao: 'Via TED', cor: 'amarelo', classeTexto: 'text-yellow-500' },
        [tipo_pagamento_poupanca]: { sigla: 'POU', descricao: 'Via Poupança', cor: 'laranja', classeTexto: 'text-orange-500' },
        [tipo_pagamento_pixqrcode]: { sigla: 'PXQ', descricao: 'Via PIX QR Code', cor: 'cyan', classeTexto: 'text-cyan-500' },
    };

    return formas[tipo_pagamento] ?? { sigla: 'OUTRO', descricao: '', cor: 'cinza', classeTexto: '' };
}

export const tipo_solicitacao_pagamento_clt_beneficio = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_CLT_BENEFICIO;
export const tipo_solicitacao_pagamento_clt_salario = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_CLT_SALARIO;
export const tipo_solicitacao_pagamento_clt_rescisao = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_CLT_RESCISAO;

export const tipo_entidade_solicitacao_financeira = import.meta.env.VITE_TIPO_ENTIDADE_SOLICITACAO_FINANCEIRA;
export const tipo_entidade_solicitacao_projeto = import.meta.env.VITE_TIPO_ENTIDADE_SOLICITACAO_PROJETO;
export const tipo_entidade_solicitacao_projeto_com_contratacao = import.meta.env.VITE_TIPO_ENTIDADE_SOLICITACAO_PROJETO_COM_CONTRATACAO;
export const tipo_entidade_solicitacao_clt = import.meta.env.VITE_TIPO_ENTIDADE_SOLICITACAO_CLT;

export const tipo_status_processo_registrado = import.meta.env.VITE_TIPO_STATUS_PROCESSO_REGISTRADO;
export const tipo_status_processo_aguardando_documentos_solicitante = import.meta.env.VITE_TIPO_STATUS_PROCESSO_AGUARDANDO_DOCUMENTOS_SOLICITANTE;
export const tipo_status_processo_aguardando_assinatura = import.meta.env.VITE_TIPO_STATUS_PROCESSO_AGUARDANDO_ASSINATURA;
export const tipo_status_processo_em_analise = import.meta.env.VITE_TIPO_STATUS_PROCESSO_EM_ANALISE;
export const tipo_status_processo_concluido = import.meta.env.VITE_TIPO_STATUS_PROCESSO_CONCLUIDO;
export const tipo_status_processo_em_tramite = import.meta.env.VITE_TIPO_STATUS_PROCESSO_EM_TRAMITE;
export const tipo_status_processo_encaminhado = import.meta.env.VITE_TIPO_STATUS_PROCESSO_ENCAMINHADO;
export const tipo_status_processo_cancelado = import.meta.env.VITE_TIPO_STATUS_PROCESSO_CANCELADO;
export const tipo_status_processo_indeferido = import.meta.env.VITE_TIPO_STATUS_PROCESSO_INDEFERIDO;
export const tipo_status_processo_deferido = import.meta.env.VITE_TIPO_STATUS_PROCESSO_DEFERIDO;
export const tipo_status_processo_resolvido = import.meta.env.VITE_TIPO_STATUS_PROCESSO_RESOLVIDO;